import React from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  return (
    <section className="legal">
      <h2 data-en="DISCLAIMER">免責事項</h2>
      <p>当サイトに掲載する情報は、正確性・最新性の確保に努めていますが、その内容を保証するものではありません。</p>
      <p>当サイトの利用により生じたいかなる損害についても、当社は責任を負いかねます。</p>

    </section>
  );
};

export default Disclaimer;


